/* eslint-disable no-mixed-spaces-and-tabs,no-param-reassign,no-tabs,@typescript-eslint/no-unused-vars */

import { ACCOUNTS_CAMPAIGNS_SELECTOR_LIST_TYPE } from '../../../../app/constants/accounts_campaigns_selector_list_type';

xplenty.directive('accountsCampaignsSelectorList', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./accounts-campaigns-selector-list.html'),

      replace: true,

      controller: 'accountsCampaignsSelectorListController',

      scope: {
        accounts: '=ngModel',
        type: '=',
        componentType: '<?',
        selectAccount: '=?',
        selectCampaign: '=?',
        removeAccount: '=?',
        removeCampaign: '=?',
        collapseAccount: '=?',
        accountsLoading: '=?',
      },

      link(scope, element, attrs) {
        scope.LIST_TYPE = ACCOUNTS_CAMPAIGNS_SELECTOR_LIST_TYPE;
      },
    };
  },
]);
